import axios, { AxiosError, AxiosResponse } from "axios";
import { eraseCookie, getCookie } from "../utils/utils";
import { Base_Url } from "../constants/base_url";

const $axios = axios.create({
  baseURL: `${Base_Url}/api`,
});

$axios.interceptors.request.use(
  async (config) => {
    const token = getCookie("ColibriToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.RequestPlatform = "web";
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);
$axios.interceptors.response.use(
  async (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);
$axios.interceptors.request.use(
  async (config) => {
    const token = getCookie("ColibriToken");
    const language = localStorage.getItem("language") || "az";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["Accept-Language"] = language;
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

$axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError<{ case?: string; message?: string }>) => {
    const status = error.response?.status;
    if (status === 403) {
      const responseData = error.response?.data as any;
      if (responseData?.case === "service_debt") {
        window.dispatchEvent(new CustomEvent("service_debt_detected"));
      } else {
        eraseCookie("ColibriToken");
        if (
          window.location.pathname !== "/" &&
          window.location.pathname !== "/auth"
        ) {
          window.location.href = "/";
        }
      }
    }
    if (status === 500) {
      const currentPath = window.location.pathname;

      const excludedPaths = ["/account/courier", "/account/mail"];

      const isExcluded = excludedPaths.some((path) =>
        currentPath.startsWith(path),
      );

      if (!isExcluded && currentPath !== "/server-error") {
        window.location.href = "/server-error";
      }
    }

    return Promise.reject(error);
  },
);

export default $axios;
